<template>
  <div class="p-4 space-y-6">
    <!-- Section : Création Livraison -->
    <Card>
      <template #title>Nouvelle Livraison</template>
      <template #content>
        <Button label="Créer Livraison" icon="pi pi-plus" @click="createDelivery" />
        <p v-if="currentDeliveryId" class="mt-2">
          Livraison créée avec ID : <b>{{ currentDeliveryId }}</b>
        </p>
      </template>
    </Card>

    <!-- Section : Ajouter une ligne -->
    <Card v-if="currentDeliveryId">
      <template #title>Ajouter des Produits</template>
      <template #content>
        <div class="flex gap-2 items-center">
          <AutoComplete
            v-model="selectedProduct"
            :suggestions="filteredProducts"
            complete-on-focus
            option-label="name"
            placeholder="Rechercher un produit..."
            @complete="searchProducts"
          />
          <InputNumber v-model="newLine.qty" :min="1" placeholder="Quantité" />
          <Button label="Ajouter" icon="pi pi-check" @click="addLine" />
        </div>

        <!-- Tableau des lignes -->
        <DataTable :value="deliveryLines" class="mt-4" striped-rows>
          <Column field="product.name" header="Produit"></Column>
          <Column field="qty" header="Quantité"></Column>
        </DataTable>
      </template>
    </Card>

    <!-- Section : Prise en charge -->
    <Card v-if="currentDeliveryId">
      <template #title>Prendre la Livraison</template>
      <template #content>
        <Button
          label="Confirmer Prise"
          icon="pi pi-box"
          severity="success"
          @click="takeDelivery"
        />
      </template>
    </Card>

    <!-- Section : Rapprochement -->
    <Card v-if="currentDeliveryId">
      <template #title>Rapprochement</template>
      <template #content>
        <div class="flex gap-2 items-center">
          <InputNumber v-model="returnQty" :min="1" placeholder="Quantité retournée" />
          <Button label="Rapprocher" icon="pi pi-refresh" @click="reconcileDelivery" />
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import { ref } from "vue";
import { Card } from "primevue/card";
import { Button } from "primevue/button";
//import { InputText } from "primevue/inputtext";
import { InputNumber } from "primevue/inputnumber";
import { AutoComplete } from "primevue/autocomplete";
import { DataTable } from "primevue/datatable";
import { Column } from "primevue/column";

import { API_URL } from "../settings";


export default {
  components: { Card, Button, InputNumber, AutoComplete, DataTable, Column },
  setup() {
    const currentDeliveryId = ref(null);
    const products = ref([]);
    const filteredProducts = ref([]);
    const selectedProduct = ref(null);
    const newLine = ref({ qty: 1 });
    const deliveryLines = ref([]);
    const returnQty = ref(0);

    // Charger tous les produits
    const loadProducts = async () => {
      const response = await fetch(`${API_URL}api/mc_chat/items`);
      products.value = await response.json();
    };

    // Recherche produit
    const searchProducts = (event) => {
      const query = event.query.toLowerCase();
      filteredProducts.value = products.value.filter((p) =>
        p.name.toLowerCase().includes(query)
      );
    };

    // Créer livraison
    const createDelivery = async () => {
      const response = await fetch(`${API_URL}api/mc_chat/deliveries`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId: 1 }) // adapte selon ton auth
      });
      const data = await response.json();
      if (response.ok) {
        currentDeliveryId.value = data.id;
        deliveryLines.value = [];
        await loadProducts();
      } else {
        alert(data.error || "Erreur création livraison");
      }
    };

    // Ajouter une ligne
    const addLine = async () => {
      if (!selectedProduct.value || !currentDeliveryId.value) return;
      const response = await fetch(`${API_URL}api/mc_chat/delivery-lines`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          deliveryId: currentDeliveryId.value,
          productId: selectedProduct.value.id,
          qty: newLine.value.qty
        })
      });
      const data = await response.json();
      if (response.ok) {
        deliveryLines.value.push({ ...data, product: selectedProduct.value });
        selectedProduct.value = null;
        newLine.value.qty = 1;
      } else {
        alert(data.error || "Erreur ajout ligne");
      }
    };

    // Prise livraison
    const takeDelivery = async () => {
      const response = await fetch(`${API_URL}api/mc_chat/deliveries/${currentDeliveryId.value}/take`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          lines: deliveryLines.value.map((l) => ({ lineId: l.id, qty_taken: l.qty }))
        })
      });
      const data = await response.json();
      if (response.ok) {
        alert("Livraison prise !");
      } else {
        alert(data.error || "Erreur prise livraison");
      }
    };

    // Rapprochement
    const reconcileDelivery = async () => {
      const response = await fetch(
        `${API_URL}api/mc_chat/deliveries/${currentDeliveryId.value}/reconcile`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            lines: [{ lineId: deliveryLines.value[0].id, qty_returned: returnQty.value }]
          })
        }
      );
      const data = await response.json();
      if (response.ok) {
        alert("Rapprochement fait !");
      } else {
        alert(data.error || "Erreur rapprochement");
      }
    };

    return {
      currentDeliveryId,
      products,
      filteredProducts,
      selectedProduct,
      newLine,
      deliveryLines,
      returnQty,
      createDelivery,
      searchProducts,
      addLine,
      takeDelivery,
      reconcileDelivery
    };
  }
};
</script>
